<template>
  <div class="importStaffStepOne">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm danh sách nhân viên</h1>
      <div class="btn-group float-right">
        <router-link class="f12 font-medium btn btn-outline-secondary" :to="`/staff`"
          >Quay lại
        </router-link>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body">
        <div class="step-content">
          <div class="step-upfile">
            <section class="open-input">
              <div class="oi-alert">
                <span v-show="keyCheckUpload === 0" style="width: 80px; display: inline-block"
                  ><img src="@/assets/img/upload.svg" alt=""
                /></span>
                <span v-show="keyCheckUpload === 1" style="width: 80px; display: inline-block"
                  ><img src="@/assets/img/upload-thanhcong.svg" alt=""
                /></span>
                <span v-show="keyCheckUpload === 2" style="width: 80px; display: inline-block"
                  ><img src="@/assets/img/upload-thatbai.svg" alt=""
                /></span>
              </div>

              <div class="input-file-container" style="width: 150px">
                <div class="mb-3 text-center">
                  <label class="f14" v-show="!typeFileUpload">Chọn loại file tải lên</label>
                  <select v-model="typeFileUpload" class="js-example-basic-single form-control f14">
                    <!-- <option value="ADD_STAFF">Thêm mới nhân viên</option> -->
                    <option value="UPDATE_STAFF">Cập nhật nhân viên</option>
                  </select>
                </div>
                <input
                  class="input-file"
                  style="display: none"
                  :disabled="!typeFileUpload"
                  id="my-file"
                  @change="uploadFileExcel"
                  type="file"
                />
                <label
                  tabindex="0"
                  for="my-file"
                  @click="checkBeforeSelectFile()"
                  style="white-space: nowrap"
                  class="btn btn-outline-secondary px-4"
                  v-show="typeFileUpload"
                  >Chọn file tải lên</label
                >
              </div>
              <p v-if="this.messFailFormat != ''" style="color: red">
                {{ this.messFailFormat }}
              </p>
            </section>
            <p v-if="fileName" class="text-primary f20 mb-2">{{ fileName }}</p>
            <p>Hỗ trợ các tệp có định dạng *.xls, *.xlsx, *.csv, *.ods</p>
            <div
              class="text-center mt-2"
              v-if="
                (typeFileUpload === 'ADD_STAFF' || !typeFileUpload) &&
                dataPermission.includes('CNPS_SUR_STAFF_DOWNLOAD_TEMPLATE')
              "
            >
              <button type="button" @click="downLoadSampleExcel()" class="btn">
                <i class="bx bx-archive-in"></i> Tải file mẫu thêm mới NV
              </button>
              <p class="text-danger">(Từ ngày 07/02/2023 cập nhật template mới)</p>
            </div>
            <button type="button" @click="downloadTempleExcelKPI()" class="btn" v-else>
              <i class="bx bx-archive-in"></i> Tải file mẫu cập nhật NV
            </button>

            <div class="text-center" v-if="showDownloadFileUploaded">
              <button @click="downloadFileUploaded()" class="btn mt-1 text-danger">
                <i class="bx bx-download"></i> Tải file vừa upload
              </button>
            </div>
          </div>

          <div class="step-upfooter">
            <button
              type="button"
              class="btn btn-primary btn-lg"
              style="width: 100%"
              @click="submitUpload()"
            >
              Xác nhận
            </button>
          </div>

          <div class="history-file table-responsive m-t-20">
            <h3 class="m-b-10">Lịch sử upfile</h3>
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Thời gian</th>
                  <th>Tên file</th>
                  <th>Người upload</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in dataHistoryUpload" :key="index">
                <tr>
                  <td>{{ item.timeUploadUTC | formatDate('DD/MM/YYYY HH:mm:ss') }}</td>
                  <td>
                    <a href="#">{{ item.fileName }}</a>
                  </td>
                  <td>{{ item.userUpload }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <NotiSuccess
      :showModalSuccess="showModalSucess"
      :messSuccess="messNoti"
      @close="showModalSucess = false"
      :hasAction="hasAction"
      :route="routeGoto"
    >
    </NotiSuccess>

    <NotiError :showModalErr="showModalErr" :messErr="messNoti" @close="showModalErr = false">
    </NotiError>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import readXlsxFile from 'read-excel-file'
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import FileDownload from 'js-file-download'
  import moment from 'moment'

  export default {
    data() {
      return {
        messFailFormat: '',
        dataHistoryUpload: [],
        keyCheckUpload: 0,
        formData: null,
        headersTbRow: [],
        dataStaffExcel: [],
        dataErrorLine: [],
        fileName: null,
        typeFileUpload: 'UPDATE_STAFF',
        showModalSucess: false,
        showModalErr: false,
        messNoti: '',
        showLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        responseUpdateFile: null,
        showDownloadFileUploaded: false,
        numberRecordExcel: null,
        hasAction: false,
        routeGoto: null,
      }
    },

    created() {
      this.getHistoryUpload()
    },

    methods: {
      async downLoadSampleExcel() {
        this.showLoading = true
        this.checkBeforeSelectFile()
        if (this.checkSelectType) await StaffService.downloadFileSample()
        this.showLoading = false
      },

      async downloadTempleExcelKPI() {
        this.showLoading = true
        this.checkBeforeSelectFile()
        if (this.checkSelectType) await StaffService.downloadFileTemplateKPI()
        this.showLoading = false
      },

      async getHistoryUpload() {
        const dataResponse = await StaffService.historyUpload()

        if (dataResponse.code === 1000) {
          this.dataHistoryUpload = dataResponse.data
        }
      },

      checkBeforeSelectFile() {
        if (!this.typeFileUpload) {
          this.showModalErr = true
          this.messNoti = 'Vui lòng chọn loại file muốn tải lên!'
          this.checkSelectType = false
        } else {
          this.checkSelectType = true
        }
      },

      async uploadFileExcel(file) {
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)

        this.fileName = file.target.files[0].name
        this.messFailFormat = ''
        this.keyCheckUpload = 1
        this.formData = new FormData()
        this.formData.append('file', file.target.files[0])
        this.formData.append('urlFile', file.target.files[0].name)
        this.parserDataExcelToJson(file.target.files[0])

        if (!checkFomat) {
          this.keyCheckUpload = 2
          this.messFailFormat = 'Định dạng không hợp lệ !'
          this.fileName = null
        }
      },

      async submitUpload() {
        try {
          if (this.formData === null) {
            this.messFailFormat = 'Vui lòng chọn file tải lên !'
          }

          this.showLoading = true

          let data = null
          if (this.typeFileUpload === 'ADD_STAFF') {
            data = await StaffService.importStatffExcel(this.formData)
          } else {
            await this.uploadFileExcelKPI()
            return
          }

          await this.$store.dispatch('staff/cacheDataErrRowExcel', [])
          await this.$store.dispatch('staff/cacheFileNameExcel', this.fileName)

          if (data.code === 1020) {
            alert('Định dạng import không đúng , tải mẫu để nhập lại')
            return
          }
          if (data.code === 1021) {
            this.dataErrorLine = data.data
            await this.$store.dispatch('staff/cacheDataErrRowExcel', data.data)
            this.$router.push({ path: 'staff-import-step-two' })
          }

          if (data.code === 1000) {
            if (this.numberRecordExcel === 0) {
              this.showFailMx('Tải lên 0 bản ghi. Vui lòng xem lại bản ghi')
            } else {
              // this.$router.push({ path: 'staff-import-step-final' })
              this.showSuccessMx(`Tải lên ${this.numberRecordExcel} bản ghi nhân viên thành công !`)
              this.hasAction = true
              this.routeGoto = 'staff'
            }
          }

          if (data.code === 1023) {
            this.showModalErr = true
            this.messNoti = 'File tải lên không có dữ liệu !'
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async uploadFileExcelKPI() {
        try {
          this.showLoading = true
          const response = (this.responseUpdateFile = await StaffService.updateStatffExcelKPI(
            this.formData
          ))
          if (response.status === 200) {
            this.showModalErr = true
            this.messNoti = `Thông tin trong file nhập không hợp lệ. Vui lòng tải file để xem chi tiết. ${this.fileName}`
            this.showDownloadFileUploaded = true
          } else if (response.status === 201) {
            this.showModalSucess = true
            this.messNoti = 'Upload file cập nhật thành công !'
            this.getHistoryUpload()
            await this.delayTime()
          } else if (response.status === 204) {
            this.showModalErr = true
            this.messNoti = 'Thông tin trong file nhập không hợp lệ. Vui lòng tải file mẫu!'
          } else if (response.status === 415 || response.status === 507) {
            this.showModalErr = true
            this.messNoti =
              'Mẫu file không hợp lệ hoặc vượt quá dung lượng quy định (tối đa 20MB). Vui lòng tải file mẫu!'
          } else if (response.code === 1029) {
            this.showModalErr = true
            this.messNoti = response.message
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      downloadFileUploaded() {
        FileDownload(
          this.responseUpdateFile.data,
          'Import_SuaNV' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
        )
      },

      async parserDataExcelToJson(data) {
        this.dataStaffExcel = []
        this.$store.dispatch('staff/cacheDataRowExcel', [])

        readXlsxFile(data).then(rows => {
          this.headersTbRow = rows[0]

          for (let i = 2; i < rows.length; i++) {
            const element = rows[i]
            const body = {
              fullName: element[0],
              mail: element[1],
              dateOfBirth: element[2],
              gender: element[3],
              phone: element[4],
              address: element[5],
              dateJoinCompany: element[6],
              code: element[7],
              role: element[8],
              position: element[9],
              manager: element[10],
              businessArea: element[11],
              province: element[12],
              lead_day: element[13],
              work_day: element[14],
              kpi_month: element[15],
              level: element[16],
              resign_date: element[17],
              is_timekeep: element[18],
              official_time: element[19],
              identify_card: element[20],
              place: element[21],
              time_range: element[22],
              contract_period: element[23],
              sign_contract_time: element[24],
              leave_day: element[25],
              is_error: false,
              descriptionValidate: '',
            }

            this.dataStaffExcel.push(body)
          }
          this.$store.dispatch('staff/cacheDataRowExcel', this.dataStaffExcel)
          this.numberRecordExcel = this.dataStaffExcel.length
        })
      },

      async delayTime() {
        setTimeout(() => {
          this.showModalSuccess = false
          this.$router.push('/staff')
        }, 1500)
      },
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
  }
</script>
